/**
 * Create the hotline click tracking object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackHotlineCTA_Click = (phoneNumber: string) => {

    const trackingPayload = {
        number: phoneNumber,
    };

    return trackingPayload;
};
